import type { Project } from '../types';
import type { DocumentSection } from './markdownParser';
import { getSectionLabels, sectionOrder } from '../prompts';

export function exportProjectMarkdown(project: Project): string {
  const locale = project.input.locale || 'en';
  const sectionLabels = getSectionLabels(locale);
  const isDe = locale === 'de';
  const header = `# ${project.name}\n\n**${isDe ? 'Erstellt mit Scalent' : 'Generated with Scalent'}**\n\n`;
  const inputSection = `## ${isDe ? 'Projektdaten' : 'Project Input'}\n\n| ${isDe ? 'Feld' : 'Field'} | ${isDe ? 'Wert' : 'Value'} |\n|-------|-------|\n| ${isDe ? 'Idee' : 'Idea'} | ${project.input.idea || ''} |\n| ${isDe ? 'Branche' : 'Industry'} | ${project.input.industry || ''} |\n| ${isDe ? 'Hauptsitz' : 'Location'} | ${project.input.location || ''} |\n| ${isDe ? 'Teamgröße / Phase' : 'Team Size / Stage'} | ${project.input.teamSize || ''} |\n| ${isDe ? 'Unternehmensphase' : 'Stage'} | ${project.input.stage || ''} |\n| ${isDe ? 'Ziele' : 'Goals'} | ${project.input.goals || ''} |\n\n---\n\n`;

  const sections = sectionOrder
    .map((key) => {
      const section = project.sections[key];
      return `## ${sectionLabels[key]}\n\n${section?.content || ''}\n\n---\n\n`;
    })
    .join('');

  return `${header}${inputSection}${sections}`;
}

export function downloadMarkdown(project: Project) {
  const markdown = exportProjectMarkdown(project);
  downloadText(markdown, `${project.name.replace(/\s+/g, '-').toLowerCase()}-${project.input.locale === 'de' ? 'unternehmensplan' : 'brand-framework'}.md`);
}

export function exportSectionMarkdown(_projectName: string, section: DocumentSection): string {
  const parts = [`# ${section.title}\n`, section.content];
  for (const sub of section.subsections) {
    parts.push(`\n## ${sub.title}\n`, sub.content);
  }
  return parts.join('\n');
}

export function downloadSection(projectName: string, section: DocumentSection) {
  const markdown = exportSectionMarkdown(projectName, section);
  const slug = section.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 50);
  const filename = `${projectName.replace(/\s+/g, '-').toLowerCase()}-${slug}.md`;
  downloadText(markdown, filename);
}

export function downloadText(text: string, filename: string) {
  const blob = new Blob([text], { type: 'text/markdown' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
